import { createPortal } from 'react-dom';
import { PurchaseAction } from '@/constants';
import { usePageData } from '@/contexts/pageContext';
import { addPurchaseActionClassname } from './addPurchaseActionClassname';
import { NotifyModal } from './NotifyModal';
import { PurchaseForm } from './PurchaseForm';

const purchasingPortal = document.querySelector('.product__purchase-options');
export const useProductPurchasing = () => {
  const { product } = usePageData();

  if (!product) {
    return null;
  }

  const purchaseAction = product.purchaseAction;

  if (purchasingPortal && purchaseAction) {
    addPurchaseActionClassname(purchasingPortal, purchaseAction);
  }

  const canPurchase = purchaseAction
    ? Object.values(PurchaseAction).includes(purchaseAction)
    : false;

  const isNotifiable =
    purchaseAction === PurchaseAction.Notify ||
    purchaseAction === PurchaseAction.None;

  const formToRender = isNotifiable ? (
    <NotifyModal sku={product.sku} productName={product.name} />
  ) : (
    <PurchaseForm />
  );

  return purchasingPortal && canPurchase
    ? createPortal(formToRender, purchasingPortal)
    : null;
};
